(() => {
  if (window.__lessulVitrineAssetLoaded) return;
  window.__lessulVitrineAssetLoaded = true;

  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function centsToMoney(cents) {
    const value = Number(cents || 0);
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const format = window.theme?.moneyFormat || window.Shopify.money_format || 'R$ {{amount}}';
        return window.Shopify.formatMoney(value, format);
      }
    } catch (error) {}
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100);
  }

  function loadHoverImages(root) {
    if (!hoverQuery.matches) return;
    root.querySelectorAll('.ls-img--hover[data-src]').forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
    });
  }

  function loadSwatchImages(root) {
    root.querySelectorAll('[data-swatch-image]').forEach((swatch) => {
      if (swatch.dataset.swatchImage) swatch.style.backgroundImage = `url("${swatch.dataset.swatchImage}")`;
      swatch.removeAttribute('data-swatch-image');
    });
  }

  function setupDots(root, track) {
    const dotsWrap = root.querySelector('[data-ls-dots]');
    if (!dotsWrap || !track) return;
    dotsWrap.replaceChildren();
    const cards = Array.from(track.querySelectorAll('[data-ls-card]'));
    if (cards.length <= 1) return;

    cards.forEach((card, index) => {
      const button = document.createElement('button');
      button.className = `ls-dot${index === 0 ? ' is-active' : ''}`;
      button.type = 'button';
      button.setAttribute('aria-label', `Ir para o produto ${index + 1}`);
      button.addEventListener('click', () => track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' }));
      dotsWrap.appendChild(button);
    });

    const dots = Array.from(dotsWrap.querySelectorAll('.ls-dot'));
    let frame = 0;
    const setActive = () => {
      frame = 0;
      const scrollLeft = track.scrollLeft;
      let activeIndex = 0;
      let smallestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - scrollLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };

    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(setActive);
    }, { passive: true });
  }

  function initialize(root) {
    if (!root || root.dataset.lsInitialized === 'true') return;
    root.dataset.lsInitialized = 'true';
    const track = root.querySelector('[data-ls-track]');
    const installmentsCount = Math.max(1, Number(root.dataset.lsInstallmentsCount) || 10);
    loadSwatchImages(root);
    loadHoverImages(root);
    setupDots(root, track);

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-ls-swatch]');
      if (swatch && root.contains(swatch)) {
        const card = swatch.closest('[data-ls-card]');
        if (!card) return;
        card.querySelectorAll('[data-ls-swatch]').forEach((item) => item.classList.remove('is-active'));
        swatch.classList.add('is-active');

        const detailsButton = card.querySelector('[data-ls-details]');
        if (detailsButton) {
          const variantId = swatch.dataset.variantId;
          const available = swatch.dataset.available === 'true';
          const productUrl = detailsButton.dataset.productUrl;
          if (variantId) {
            detailsButton.dataset.variantId = variantId;
            if (productUrl) detailsButton.href = `${productUrl}?variant=${variantId}`;
          }
          if (available) {
            detailsButton.removeAttribute('aria-disabled');
            detailsButton.textContent = 'Comprar agora';
          } else {
            detailsButton.setAttribute('aria-disabled', 'true');
            detailsButton.textContent = 'Indisponível';
          }
        }

        const price = Number(swatch.dataset.price || 0);
        const compareAt = Number(swatch.dataset.compare || 0);
        const pixPrice = Math.ceil(price * 0.95);
        const priceElement = card.querySelector('[data-ls-current]');
        const compareElement = card.querySelector('[data-ls-compare]');
        const compareLine = card.querySelector('[data-ls-compare-line]');
        const installmentElement = card.querySelector('[data-ls-installment-value]');
        if (priceElement) priceElement.textContent = centsToMoney(pixPrice);
        if (installmentElement) installmentElement.textContent = centsToMoney(Math.round(price / installmentsCount));

        const hasCompareAt = compareAt > price && compareAt > 0;
        if (compareLine) compareLine.style.display = hasCompareAt ? '' : 'none';
        if (hasCompareAt && compareElement) compareElement.textContent = centsToMoney(compareAt);

        const mainImage = card.querySelector('.ls-img--main');
        if (mainImage && swatch.dataset.image) {
          mainImage.src = swatch.dataset.image;
          if (swatch.dataset.imageSrcset) mainImage.srcset = swatch.dataset.imageSrcset;
        }
        return;
      }

      const detailsButton = event.target.closest('[data-ls-details]');
      if (detailsButton?.getAttribute('aria-disabled') === 'true') event.preventDefault();
    });
  }

  const scheduled = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      initialize(entry.target);
      instance.unobserve(entry.target);
    });
  }, { rootMargin: '500px 0px' }) : null;

  function schedule(root) {
    if (!root || root.dataset.lsInitialized === 'true' || scheduled.has(root)) return;
    scheduled.add(root);
    if (observer) observer.observe(root);
    else initialize(root);
  }

  function bootstrap(container = document) {
    if (container.matches?.('.ls-vitrine')) schedule(container);
    container.querySelectorAll?.('.ls-vitrine').forEach(schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bootstrap(), { once: true });
  else bootstrap();

  document.addEventListener('shopify:section:load', (event) => bootstrap(event.target));
  hoverQuery.addEventListener?.('change', () => {
    if (hoverQuery.matches) document.querySelectorAll('.ls-vitrine[data-ls-initialized="true"]').forEach(loadHoverImages);
  });
})();
